import React from 'react';
import useBrandContext from 'contexts/brand.context';
import { convertTimeto12hrs } from 'utils/functions';
import BrandWorkingHour from 'components/brand-working-hour';
import { WorkingHoursType } from 'utils/types';

const PreviewBrandOpeningTime = () => {
  const { createBrandForm } = useBrandContext();
  return (
    <div>
      {createBrandForm?.working_hours?.map(
        (item: WorkingHoursType, index: React.Key | null | undefined) => {
          return (
            item.active && (
              <BrandWorkingHour
                key={index}
                day={item.name}
                openingTime={convertTimeto12hrs(item.opening_time)}
                closingTime={convertTimeto12hrs(item.closing_time)}
              />
            )
          );
        }
      )}
    </div>
  );
};

export default PreviewBrandOpeningTime;
